<nav id="ac-globalnav" class="js no-touch" role="navigation" aria-label="Global" data-hires="false" data-analytics-region="global nav" lang="en-US" dir="ltr" data-store-locale="us" data-store-api="/[storefront]/shop/bag/status" data-search-locale="en_US"
    data-search-api="/search-services/suggestions/">

    <div *ngIf="searchBox" class="ac-gn-search-placeholder-container" role="search">
        <div class="ac-gn-search ac-gn-search-small">
            <a id="ac-gn-link-search-small" class="ac-gn-link" data-analytics-title="search" data-analytics-click="search" data-analytics-intrapage-link="" [attr.aria-label]="equipmentProviderInActive ? 'Search hspracticepay.com' : 'Search icreditworks.com'" role="button" aria-haspopup="true">
                <div class="ac-gn-search-placeholder-bar">
                    <div class="ac-gn-search-placeholder-input">
                        <div class="ac-gn-search-placeholder-input-text" aria-hidden="true">
                            <div class="ac-gn-link-search ac-gn-search-placeholder-input-icon"></div>
                            <span class="ac-gn-search-placeholder">{{ equipmentProviderInActive ? 'Search hspracticepay.com' : 'Search icreditworks.com' }}</span>
                        </div>
                    </div>
                    <div class="ac-gn-searchview-close ac-gn-searchview-close-small ac-gn-search-placeholder-searchview-close">
                        <span class="ac-gn-searchview-close-cancel" aria-hidden="true">Cancel</span>
                    </div>
                </div>
            </a>
        </div>
    </div>
    <aside *ngIf="searchBox" id="ac-gn-searchview" style="display: block; position: relative; height: 100%;" class="ac-gn-searchview" role="search" data-analytics-region="search">
        <div class="ac-gn-searchview-content">
            <div class="ac-gn-searchview-bar" style="height: 100%;">
                <div class="ac-gn-searchview-bar-wrapper" style="height: 100%;">
                    <form id="ac-gn-searchform" class="ac-gn-searchform" *ngIf="searchBox" method="get">
                        <div class="ac-gn-searchform-wrapper">
                            <input (keyup)="updateListOnChange($event)" id="ac-gn-searchform-input" class="ac-gn-searchform-input" type="text" [attr.aria-label]="equipmentProviderInActive ? 'Search hspracticepay.com' : 'Search icreditworks.com'" [placeholder]="equipmentProviderInActive ? 'Search hspracticepay.com' : 'Search icreditworks.com'" autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="false">
                            <input id="ac-gn-searchform-src" type="hidden" name="src" value="globalnav">
                            <!-- <button id="ac-gn-searchform-submit" class="ac-gn-searchform-submit some_search_btn" type="submit" disabled="" -->
                            <button id="ac-gn-searchform-submit" class="ac-gn-searchform-submit" type="submit" disabled="" aria-label="Submit Search">
                <img style="height: 1.15rem; filter: brightness(1.9); margin-top: .2rem;" [src]="sharedDataService.assetsCdn('images/search-copy.svg')" alt="" loading="lazy">
              </button>
                            <button id="ac-gn-searchform-reset" class="ac-gn-searchform-reset" type="reset" disabled="" aria-label="Clear Search">
                <span class="ac-gn-searchform-reset-background"></span>
              </button>
                            <button id="ac-gn-searchview-close" (click)="cancelSearch()"  aria-label="Cancel Search">
                <span *ngIf="searchBox" class="icon icon_cross-light" style="margin-top: .3rem; height: 1.15rem; width: 1.15rem;">
                  <!-- <span class="ac-gn-searchview-close-left"></span>
                  <span class="ac-gn-searchview-close-right"></span> -->
                </span>
              </button>
                        </div>
                    </form>
                    <button id="ac-gn-searchview-close-small" class="ac-gn-searchview-close ac-gn-searchview-close-small" aria-label="Cancel Search">
            <span class="ac-gn-searchview-close-cancel" aria-hidden="true">
              Cancel
            </span>
          </button>
                </div>
            </div>
            <!-- <aside *ngIf="searchBox" style="display: block; background-color: wheat;" id="ac-gn-searchresults" class="ac-gn-searchresults" -->
            <aside *ngIf="searchBox" style="display: block; width: 100%; border-top: solid 1px #c4c4c4; position: absolute; top: 98%;" id="ac-gn-searchresults" class="ac-gn-searchresults" data-string-quicklinks="Quick Links" data-string-suggestions="Suggested Searches" data-string-noresults="">
                <section class="ac-gn-searchresults-section ac-gn-searchresults-section-defaultlinks" data-analytics-region="defaultlinks search">
                    @for (key of dataKeys; track $index) {
                    @if (key) {
                    <div class="ac-gn-searchresults-section-wrapper">
                        <h3 class="ac-gn-searchresults-header ac-gn-searchresults-animated">{{key}}</h3>
                        <ul class="ac-gn-searchresults-list">
                            <li *ngFor="let linkData of dataFormatted[key];let idxL = index"
                                class="ac-gn-searchresults-item ac-gn-searchresults-animated">
                                <a (click)="clickSearch($event)" [attr.data-link]="linkData.URL"
                                    class="ac-gn-searchresults-link ac-gn-searchresults-link-defaultlinks">{{linkData.Text}}</a>
                            </li>
                        </ul>
                    </div>
                    }
                    }
                </section>

            </aside>
        </div>
    </aside>
    <aside class="ac-gn-bagview" data-analytics-region="bag">
        <div class="ac-gn-bagview-scrim">
            <span class="ac-gn-bagview-caret ac-gn-bagview-caret-small"></span>
        </div>
        <div class="ac-gn-bagview-content" id="ac-gn-bagview-content">
        </div>
    </aside>
    <!-- </div> -->
</nav>
